"use strict";
/* eslint-disable max-len */
const { object, string } = require('../../utils/modifiedYup');
const { rawContentSchema, displayComponentContentSchema, templateContentSchema, builderContentSchema, } = require('./contentSchema');
const smsMessageSchema = object().shape({
    type: string().oneOf(['sms']).required(),
    content: object()
        .oneOfSchemas([rawContentSchema, templateContentSchema])
        .required(),
});
const emailMessageSchema = object().shape({
    type: string().oneOf(['email']).required(),
    content: object()
        .oneOfSchemas([
        rawContentSchema,
        displayComponentContentSchema,
        templateContentSchema,
        builderContentSchema,
    ])
        .required(),
});
module.exports = {
    smsMessageSchema,
    emailMessageSchema,
};
//# sourceMappingURL=messageSchema.js.map